/**
* 基础菜单 商品管理
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>数据大盘</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">


            <el-form-item prop="beginTime" label="数据时间">
                <el-col :span="11">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"  type="datetime" placeholder="选择日期"
                        v-model="formInline.beginTime" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
                <el-col :span="11">
                    <el-form-item prop="endTime" label="">
                        <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                            placeholder="选择日期" v-model="formInline.endTime" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
                <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
            </el-form-item>
            <el-form-item>
            </el-form-item>

        </el-form>


        <!--列表-->
        <div class="separator">

            <span class="separator-x"> <i class="el-icon-s-flag"></i> 总注册数据</span>







            <div style="margin-top: 30px;">
    <el-row :gutter="24" style="font-size: 20px;">
        <el-col :span="3">
        <div>
          <el-statistic title="🚩总注册用户">
            <template slot="formatter">
                <span style="font-size: 26px; font-weight: 700; color: blueviolet;">  {{
                formLIst.registerManCount + formLIst.registerWoManCount }}</span>

            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="男生人数">
            <template slot="formatter">
            {{ formLIst.registerManCount }}
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="女生人数">
            <template slot="formatter">
                {{ formLIst.registerWoManCount }}
            </template>
          </el-statistic>
        </div>
      </el-col>

      <el-col :span="2">
        <div>
          <el-statistic title="🚩新增总订单">
            <template slot="formatter">
                {{formLIst.payActivityCount + formLIst.freeActivityCount + formLIst.payPhoneOrderCount }}
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="付费活动">
            <template slot="formatter">
            {{ formLIst.payActivityCount }}个
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="免费活动">
            <template slot="formatter">
                {{ formLIst.freeActivityCount }}个
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="咨询订单">
            <template slot="formatter">
                {{ formLIst.payPhoneOrderCount }}个
            </template>
          </el-statistic>
        </div>
      </el-col>

      <el-col :span="2">
        <div>
          <el-statistic title="🚩总收入">
            <template slot="formatter">
                {{ formLIst.payActivityAmount+ formLIst.payPhoneOrderAmount}}元
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="付费活动">
            <template slot="formatter">
                {{ formLIst.payActivityAmount}}元
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="咨询订单">
            <template slot="formatter">
                {{  formLIst.payPhoneOrderAmount}}元
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="3">
        <div>

          <el-statistic title="🚩总退费">
            <template slot="formatter">
                {{ formLIst.refundAmount}}元
            </template>
          </el-statistic>
        </div>
      </el-col>

    </el-row>



<el-row :gutter="20" style="margin-top: 50px; ">

 <el-col :span="3">
        <div>
          <el-statistic title="🚩今日男头像通过率">
            <template slot="formatter">
                {{ formLIst.manHeadIcon10to30Count+formLIst.manHeadIcon31to50Count+formLIst.manHeadIcon51to80Count+formLIst.manHeadIcon81to100Count}}人/ <span style="color: black;">{{formLIst.manHeadIconPassRate}}%</span>
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="男不通过">
            <template slot="formatter">
                {{  formLIst.manHeadIconNotPassedCount}}人
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="男10-30分">
            <template slot="formatter">
                {{  formLIst.manHeadIcon10to30Count}}人
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="男31-50分">
            <template slot="formatter">
                {{  formLIst.manHeadIcon31to50Count}}人
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="男51-80分">
            <template slot="formatter">
                {{  formLIst.manHeadIcon51to80Count}}人
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="2">
        <div>
          <el-statistic title="男81-100分">
            <template slot="formatter">
                {{  formLIst.manHeadIcon81to100Count}}人
            </template>
          </el-statistic>
        </div>
      </el-col>

</el-row>

<el-row :gutter="20" style="margin-top: 50px;">

<el-col :span="3">
       <div>
         <el-statistic title="🚩今日女头像通过率">
           <template slot="formatter">
            <span>{{ formLIst.womanHeadIcon10to30Count+formLIst.womanHeadIcon31to50Count+formLIst.womanHeadIcon51to80Count+formLIst.womanHeadIcon81to100Count}}人/ <span style="color: black; font-size: 22px;">{{formLIst.womanHeadIconPassRate}}%</span></span>
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="女不通过">
           <template slot="formatter">
            {{  formLIst.womanHeadIconNotPassedCount}}人

           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="女10-30分">
           <template slot="formatter">
            {{  formLIst.womanHeadIcon10to30Count}}人
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="女31-50分">
           <template slot="formatter">
            {{  formLIst.womanHeadIcon31to50Count}}人

           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="女51-80分">
           <template slot="formatter">
            {{  formLIst.womanHeadIcon51to80Count}}人
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="女81-100分">
           <template slot="formatter">
            {{  formLIst.womanHeadIcon81to100Count}}人
           </template>
         </el-statistic>
       </div>
     </el-col>
</el-row>
  </div>
          </div>
        <div class="separator" style="float: left; margin-top: 50px;">
<span class="separator-x"> <i class="el-icon-data-analysis"></i> 今日注册数据<span style="font-size: 16px;">(不执行筛选结果)</span></span>
<el-row :gutter="20" style="margin-top: 50px;">

<el-col :span="3">
       <div>
         <el-statistic title="🚩今日新增用户">
           <template slot="formatter">
            <span style="font-size: 26px; font-weight: 700; color: blueviolet;"> {{
    getTodayDatalist.registerManCount + getTodayDatalist.registerWoManCount }}</span>

           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="男生人数">
           <template slot="formatter">
            {{ getTodayDatalist.registerManCount }}人

           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="女生人数">
           <template slot="formatter">
            {{  getTodayDatalist.registerWoManCount}}人
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="3">
       <div>
         <el-statistic title="🚩今日注册用户订单数">
           <template slot="formatter">
            {{getTodayDatalist.payActivityCount + getTodayDatalist.freeActivityCount + getTodayDatalist.payPhoneOrderCount }}
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="付费活动">
           <template slot="formatter">
            {{  getTodayDatalist.payActivityCount}}个
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="免费活动">
           <template slot="formatter">
            {{  getTodayDatalist.freeActivityCount}}个
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="咨询订单">
           <template slot="formatter">
            {{  getTodayDatalist.payPhoneOrderCount}}个

           </template>
         </el-statistic>
       </div>
     </el-col>

</el-row>

<el-row :gutter="20" style="margin-top: 50px; ">
    <el-col :span="3">
       <div>
         <el-statistic title="🚩今日注册用户付费">
           <template slot="formatter">
            {{ getTodayDatalist.payActivityAmount+ getTodayDatalist.payPhoneOrderAmount}}元
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="付费活动">
           <template slot="formatter">
            {{  getTodayDatalist.payActivityAmount}}元
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="咨询订单">
           <template slot="formatter">
            {{  getTodayDatalist.payPhoneOrderAmount}}元
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="🚩今日退费">
           <template slot="formatter">
            {{ getTodayDatalist.refundAmount}}元
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="🚩今日ARPU">
           <template slot="formatter">
            {{ getTodayDatalist.arpu}}
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="3">
       <div>
         <el-statistic title="🚩当前在线人数">
           <template slot="formatter">
            {{ getTodayDatalist.onlineManCount+getTodayDatalist.onlineWoManCount}}

           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="男在线">
           <template slot="formatter">
            {{  getTodayDatalist.onlineManCount}}人
           </template>
         </el-statistic>
       </div>
     </el-col>
     <el-col :span="2">
       <div>
         <el-statistic title="女在线">
           <template slot="formatter">
            {{  getTodayDatalist.onlineWoManCount}}人
           </template>
         </el-statistic>
       </div>
     </el-col>
</el-row>




</div>
    </div>
</template>

<script>
import Vue from 'vue'
import { roleAdd, roleDelete, roleEdit, getListByRole, getMenuList, menuEdit, getAllData,getTodayData } from '../../api/userMG'
import Axios from 'axios'
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            dialogVisible: false,
            value: "",
            options123: [],
            drawer: false,
            roleIdls: '',
            formLIst: [],
            datas: [],
            like: true,
            value1: 4154.564,
            value2: 1314,
            title: "增长人数",

            expandedlist: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            ssoServer: "",
            formLabelWidth: '120px',
            dialogFormVisible: false,
            options1234123: [],
            ifindex: "",
            adder: "",
            recommendform: {
                index: "",
                id: ""
            },
            roleId: "",
            getTodayDatalist:[],
            nshow: true, //switch开启
            fshow: false, //switch关闭
            importList: [],
            SelectList: '',
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏


            editForm: {
                name: '',
            },

            // rules表单验证
            rules: {
                name: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
            },
            formInline: {
                beginTime: "",
                endTime: ""
            },
            ids: "",
            userparm: [], //搜索权限
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            }
        }
    },

    // 注册组件
    components: {
        Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {

        this.ongetAllData()
        this.ongetTodayData()
        this.roleId = JSON.parse(localStorage.getItem('userlist'))
        this.ssoServer = Vue.prototype.GLOBAL.ssoServer
        this.formInline.beginTime =this.timeDefault
        this.formInline.endTime =this.timeDefaults
        let tokenId = localStorage.getItem('tokenId');
        this.adder = tokenId
    },
    computed: {
    timeDefault() {
      var date = new Date();
      var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate())+ " " +'00:00:00';
      return s1;

    },
    timeDefaults(){
        var date = new Date();
        var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate())+ " " +'23:59:59';
      return s1;
    }
  },

    mounted() {
        // this.formLIst()



    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        ongetTodayData(){
            getTodayData().then(res=>{
               this.getTodayDatalist =res.data
            })
        },
        ongetAllData() {
            getAllData(this.formInline).then(res => {
                this.formLIst = res.data
                // console.log(res.data);
            })
        },
        onClick(row, index) {
            if (index == 2) {
                this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    roleDelete({
                        id: row.id
                    }).then(res => {
                        if (res.code == 0) {
                            this.loadListByRole()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
                // 删除
            } else {

                this.drawer = true
                this.expandedlist = row.menuIds
                this.roleIdls = row.roleId


                return
                this.ifindex = '2'
                this.ids = row.id
                this.editForm.name = row.name
                this.dialogFormVisible = true

                // 编辑

            }
        },
        onsetCheckedKeys() {

            this.$refs.tree.setCheckedKeys([]);
            this.drawer = false
        },
        onsetCheckedKey() {

            this.$refs.tree.setCheckedKeys([]);
            this.drawer = false
        },
        addRole() {


            this.expandedlist = this.$refs.tree.getCheckedKeys()
            menuEdit({
                menuId: this.expandedlist,
                roleId: this.roleIdls
            }).then(res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                    this.loadListByRole()
                    this.$refs.tree.setCheckedKeys([]);
                    this.drawer = false

                }
            })
            return
            if (this.ifindex == 1) {
                roleAdd({
                    name: this.editForm.name
                }).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '添加成功'
                        })
                        this.loadListByRole()
                        this.dialogFormVisible = false

                    }
                })
            } else {
                roleEdit({
                    name: this.editForm.name,
                    id: this.ids
                }).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '编辑成功'
                        })
                        this.loadListByRole()
                        this.dialogFormVisible = false

                    }
                })
            }


        },




        recommend(i, f) {
            if (i == -1) {
                this.recommendform.id = f.id
                this.recommendform.index = 0

                this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {


                    Axios({
                        method: 'post',
                        url: this.ssoServer + '/api/activity/updateIndex',

                        headers: {
                            tokenId: this.adder
                        },
                        data: this.recommendform
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '取消成功'
                            })
                            this.loadListByRole()
                        }
                    })

                }).catch(() => {

                });
                return

            } else {
                this.editFormVisible = true

            }
            this.recommendform.id = f.id


            this.recommendform.index = ''

        },




        addCogilg() {
            this.ifindex = '1'
            this.editForm.name = ''
            this.dialogFormVisible = true
        },
        selectall(val) {
            // console.log(val);

            let data = []
            // this.importList=''
            val.forEach((item) => {
                data.push(item.id)
                this.importList = data
                console.log(this.importList);

            })

            // this.importList
            // console.log(val);
        },



        change1(e) {
            console.log("change1", e);
            if (e.length === 1) {
                this.$message({
                    type: 'error',
                    message: '请选择详细地址'
                })
            }
            if (e.length === 2) {
                this.formInline.registerAddress = e[1];
            }
        },

        selectalls(rows) {

            if (rows) {
                let data = []
                rows.forEach((item) => {
                    data.push(item.id)
                    this.importList = data
                    console.log(this.importList);

                })
                rows.forEach(row => {

                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                console.log('1212112');
                this.importList = []

                this.$refs.multipleTable.clearSelection();//清除全选
            }


        },

        onChange(e, l) {
            console.log(e, l);

            // this.formInline.activityAddressCode = e[1]
            // console.log( this.formInline.registerAddress);


        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 导出数据
        imporList() {
            if (this.importList.length == 0) {

                this.$message({
                    type: 'warning',
                    message: '请选择要导出的数据'
                })
                return

            } else {
                Axios({
                    method: 'post',

                    url: this.ssoServer + '/api/platform-account/exportExcel',
                    headers: {
                        tokenId: this.adder
                    },
                    data: {
                        accountIds: this.importList,
                        searchType: 1
                    },
                    responseType: 'blob'
                }).then(res => {
                    const link = document.createElement('a') // 创建a标签
                    const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
                    link.href = window.URL.createObjectURL(blob)
                    const filename = res.headers['content-disposition'].split('filename=')[1]
                    link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
                    link.click()
                    window.URL.revokeObjectURL(link.href)
                })


            }




        },
        select(selection, row) {

            let data = []
            // this.importList=''
            selection.forEach((item) => {
                data.push(item.id)
                this.importList = data
                console.log(this.importList);

            })

            // console.log(this.importList);
            // console.log(selection);
        },
        resetForm(formInline) {
            //  this.formInline =''
            this.$refs[formInline].resetFields();
        },
        loadListByRole() {
            getListByRole(this.formInline).then(res => {
                if (res.code == 0) {
                    this.listData = res.data
                    this.pageparm.total = res.data.total
                }
            })
        },
        formatData(row, column, cellValue, index) {

            //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
            //最终返回 s 就可以了
            var s = new Date(cellValue).toLocaleString();
            return s;
        },
        handleSizeChange(e) {
            // reru console.log(e.pageSize);
            this.formInline.size = e.pageSize
            this.formInline.current = e.currentPage

            this.loadListByRole()
            // console.log(e);
        },
        // 分页插件事件
        callFather(parm) {
            console.log(parm);

            this.formInline.size = parm.pageSize
            this.formInline.current = parm.currentPage
            this.loadListByRole()
        },
        // 搜索事件
        search() {

            this.value = (new Date()).getTime();

            this.ongetAllData()
        },
        //显示编辑界面
        handleEdit: function (index, row) {
            this.$router.push({
                path: "/Eventmanagement/Eventdetails",
                query: { //query是个配置项
                    id: row.id
                }
            })

            // this.editFormVisible = true
            // if (row != undefined && row != 'undefined') {
            //   this.title = '修改'
            //   this.editForm.deptId = row.deptId
            //   this.editForm.deptName = row.deptName
            //   this.editForm.deptNo = row.deptNo
            // } else {
            //   this.title = '添加'
            //   this.editForm.deptId = ''
            //   this.editForm.deptName = ''
            //   this.editForm.deptNo = ''
            // }
        },
        // 编辑、增加页面保存方法
        submitForm(editData) {
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if (this.recommendform.index == '') {
                        return this.$message({
                            type: 'warning',
                            message: '推荐排序不能为空'
                        })
                    }
                    Axios({
                        method: 'post',
                        url: this.ssoServer + '/api/activity/updateIndex',

                        headers: {
                            tokenId: this.adder
                        },
                        data: this.recommendform
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '推荐成功'
                            })
                            this.editFormVisible = false
                            this.loadListByRole()

                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.data.message
                            })
                            return

                        }


                    })
                }
            })
        },
        // async logins() {
        //     // 网络请求
        //     let data = await login('1111111');
        //     // let token = data.token;
        //     // 本地  vuex
        //     // this.$store.commit('LOGIN_IN',token);
        //     this.$router.replace("/")
        // },

        // 删除公司

        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible = false
        }
    }
}
</script>

<style scoped>
.separator {
    width: 100%;
    /* margin-left: 1%; */
    /* height: 1000px; */
    /* border: 1px solid #ccc; */
    /* background-color: rebeccapurple; */


}

.separator-x {

    font-weight: 600;
    font-size: 24px;
}

.separator-clo {

    width: 20px;
    height: 80px;
    border-radius: 10px;
    background-color: darkorchid;
}

.like {
    cursor: pointer;
    font-size: 25px;
    display: inline-block;
}

.user-search {
    margin-top: 20px;
}


.userRole {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/Datadashboard.vue